import { Component, OnInit } from '@angular/core';
import { BookmarkVisibilityValue } from 'app/services/bookmark.service';
import { BookmarkService, BookmarkTypeValue, MapBookmark } from 'app/services/bookmark.service';

@Component({
  selector: 'app-feat-reference-document-tab',
  templateUrl: './feat-reference-document-tab.component.html',
  styleUrls: ['./feat-reference-document-tab.component.css']
})
export class FeatReferenceDocumentTabComponent implements OnInit {

	bookmarkListByVisib: {
		visib: BookmarkVisibilityValue;
		list: MapBookmark[];
	}[];

	private bookmarkList: MapBookmark[];
	constructor(
		private bookmarkService: BookmarkService
	) { }

	async ngOnInit() {
		this.bookmarkList = await this.bookmarkService.getMapBookmarks('HREF');
		const obj: {
			[type in BookmarkVisibilityValue]: MapBookmark[]
		} = {
			'Personal': [],
			'Agency': [],
			'State': [],
			'System': []
		}
		this.bookmarkList.forEach(i => {
			if (obj[i.visibility]) {
				obj[i.visibility].push(i);
			}
		});
		this.bookmarkListByVisib = [];
		if (obj.Personal.length) {
			this.bookmarkListByVisib.push({
				visib: 'Personal',
				list: obj.Personal
			})
		}
		if (obj.Agency.length) {
			this.bookmarkListByVisib.push({
				visib: 'Agency',
				list: obj.Agency
			})
		}
		if (obj.State.length) {
			this.bookmarkListByVisib.push({
				visib: 'State',
				list: obj.State
			});
		}
		if (obj.System.length) {
			this.bookmarkListByVisib.push({
				visib: 'System',
				list: obj.System
			});
		}
	}

}
